<div id="top-of-page"></div>

<app-back-header
  [headerText]="'Torna alla dashboard'"
  (backAction)="backToDashboard()"
  class="sticky-top"
></app-back-header>

<div class="mt-3 ms-1 mb-3 d-flex flex-wrap align-items-start justify-content-between gap-2">
  <div>
    <h3 class="m-0">La tua bacheca</h3>
    <p class="m-0 text-muted">
      Fatture, scadenze fiscali e impegni personali, giorno per giorno.
    </p>
  </div>

  <button
    matButton="filled"
    type="button"
    class="izy-button-primary custom-button-border board-add-button"
    (click)="addActivity()"
  >
    <mat-icon>add</mat-icon>
    Nuova attività
  </button>
</div>

<!-- Filtri: spengono un'intera famiglia di contenuti in griglia e in agenda. -->
<div class="board-filters mb-3" role="group" aria-label="Filtra il contenuto della bacheca">
  @for (chip of filterChips; track chip.category) {
    <button
      type="button"
      class="board-chip"
      [class.board-chip--off]="!isFilterActive(chip.category)"
      [attr.data-category]="chip.category"
      [attr.aria-pressed]="isFilterActive(chip.category)"
      (click)="toggleFilter(chip.category)"
    >
      <mat-icon fontSet="material-icons-outlined">{{ chip.icon }}</mat-icon>
      {{ chip.label }}
    </button>
  }
</div>

<div class="row g-3">
  <!-- Su mobile le scadenze vengono prima: sono la cosa che non si può perdere. -->
  <div class="col-12 col-lg-4 order-1 order-lg-2">
    <mat-card class="h-100 izy-sharp-br custom-card-border izy-panel d-flex flex-column">
      <mat-card-content class="p-3 flex-grow-1 d-flex flex-column">
        <div class="izy-panel-heading">
          <span class="izy-corner-icon">
            <mat-icon fontSet="material-icons-outlined">push_pin</mat-icon>
          </span>
          <h5 class="izy-panel-title m-0">Prossime scadenze</h5>
        </div>
        <p class="izy-panel-subtitle">
          Le quattro più vicine tra scadenze da pagare e attività da fare.
        </p>

        @if (loading() && upcoming().length === 0) {
          <div class="board-loading board-loading--compact">
            <mat-progress-spinner
              diameter="36"
              mode="indeterminate"
            ></mat-progress-spinner>
          </div>
        } @else if (upcoming().length === 0) {
          <div class="board-empty">
            <mat-icon fontSet="material-icons-outlined">task_alt</mat-icon>
            <p class="m-0">Nessuna scadenza in arrivo.</p>
          </div>
        } @else {
          <div class="postit-stack">
            @for (note of upcoming(); track note.key) {
              <button
                type="button"
                class="postit"
                [attr.data-urgency]="note.urgency"
                [attr.data-kind]="note.kind"
                (click)="openDeadline(note)"
              >
                <span class="postit__countdown">
                  <mat-icon fontSet="material-icons-outlined">
                    {{ note.icon }}
                  </mat-icon>
                  {{ note.label }}
                </span>
                <span class="postit__title">{{ note.title }}</span>
                <span class="postit__date">
                  {{ note.date | date: 'EEEE d MMMM' }}
                </span>
                @if (note.amount) {
                  <span class="postit__amount">
                    {{ note.amount | currency: 'EUR' }}
                  </span>
                }
              </button>
            }
          </div>
        }

        <button
          mat-stroked-button
          type="button"
          class="izy-button-ghost izy-button-ghost--info custom-button-border mt-3 w-100"
          (click)="goToFiscalPlan()"
        >
          Vedi la previsione fiscale annuale
          <mat-icon>chevron_right</mat-icon>
        </button>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- Calendario -->
  <div class="col-12 col-lg-8 order-2 order-lg-1">
    <mat-card class="h-100 izy-sharp-bl custom-card-border izy-panel d-flex flex-column">
      <mat-card-content class="p-3 flex-grow-1 d-flex flex-column">
        <div class="month-nav">
          <button
            mat-icon-button
            type="button"
            matTooltip="Mese precedente"
            aria-label="Mese precedente"
            (click)="previousMonth()"
          >
            <mat-icon>chevron_left</mat-icon>
          </button>

          <h5 class="month-nav__label m-0">{{ monthLabel() }}</h5>

          <button
            mat-icon-button
            type="button"
            matTooltip="Mese successivo"
            aria-label="Mese successivo"
            (click)="nextMonth()"
          >
            <mat-icon>chevron_right</mat-icon>
          </button>

          <button
            mat-stroked-button
            type="button"
            class="izy-button-ghost custom-button-border month-nav__today"
            (click)="goToToday()"
          >
            <mat-icon fontSet="material-icons-outlined">today</mat-icon>
            Oggi
          </button>
        </div>

        @if (loading()) {
          <div class="board-loading">
            <mat-progress-spinner
              diameter="50"
              mode="indeterminate"
            ></mat-progress-spinner>
          </div>
        } @else {
          <!-- Griglia mensile: solo da tablet in su. -->
          <div class="board-grid-wrapper d-none d-md-block">
            <div class="board-weekdays" aria-hidden="true">
              @for (day of weekdays; track day) {
                <span class="board-weekday">{{ day }}</span>
              }
            </div>

            <div class="board-grid">
              @for (cell of cells(); track cell.dayKey) {
                <button
                  type="button"
                  class="board-cell"
                  [class.board-cell--out]="!cell.inMonth"
                  [class.board-cell--today]="cell.today"
                  [class.board-cell--weekend]="cell.weekend"
                  [attr.aria-label]="(cell.date | date: 'fullDate') + ', ' + cell.items.length + ' voci'"
                  (click)="openDay(cell)"
                >
                  <span class="board-cell__head">
                    <span class="board-cell__number">{{ cell.dayNumber }}</span>
                    @if (cell.issuedTotal) {
                      <span
                        class="board-cell__total"
                        matTooltip="Fatturato emesso in giornata"
                      >
                        {{ cell.issuedTotal | currency: 'EUR' : 'symbol' : '1.0-0' }}
                      </span>
                    }
                  </span>

                  <span class="board-cell__items">
                    @for (item of cell.visibleItems; track item.key) {
                      <span
                        class="board-pill"
                        [attr.data-kind]="item.kind"
                        [class.board-pill--settled]="item.settled"
                        [class.board-pill--important]="item.important"
                        [matTooltip]="item.title"
                      >
                        <mat-icon fontSet="material-icons-outlined">{{ item.icon }}</mat-icon>
                        <span class="board-pill__text">{{ item.title }}</span>
                      </span>
                    }

                    @if (cell.hiddenCount) {
                      <span class="board-cell__more">
                        +{{ cell.hiddenCount }} altre
                      </span>
                    }
                  </span>
                </button>
              }
            </div>
          </div>

          <!-- Agenda: sotto i 768px la griglia a 7 colonne è illeggibile. -->
          <div class="board-agenda d-block d-md-none">
            @if (agendaDays().length === 0) {
              <div class="board-empty">
                <mat-icon fontSet="material-icons-outlined">event_available</mat-icon>
                <p class="m-0">Nessun impegno in questo mese.</p>
              </div>
            } @else {
              @for (cell of agendaDays(); track cell.dayKey) {
                <button
                  type="button"
                  class="agenda-day"
                  [class.agenda-day--today]="cell.today"
                  (click)="openDay(cell)"
                >
                  <span class="agenda-day__date">
                    <span class="agenda-day__number">{{ cell.dayNumber }}</span>
                    <span class="agenda-day__weekday">
                      {{ cell.date | date: 'EEE' }}
                    </span>
                  </span>

                  <span class="agenda-day__items">
                    @for (item of cell.items; track item.key) {
                      <span
                        class="board-pill"
                        [attr.data-kind]="item.kind"
                        [class.board-pill--settled]="item.settled"
                        [class.board-pill--important]="item.important"
                      >
                        <mat-icon fontSet="material-icons-outlined">{{ item.icon }}</mat-icon>
                        <span class="board-pill__text">{{ item.title }}</span>
                      </span>
                    }
                  </span>
                </button>
              }
            }
          </div>
        }
      </mat-card-content>
    </mat-card>
  </div>
</div>

<div class="pt-3 mb-3"></div>
